import { Component } from '@angular/core';


@Component({
    selector: 'cookie-info',
    templateUrl: './cookie.info.template.html',
    standalone: false
})
export class CookieInfoComponent {

    public popupVisible: true;

    public openCookieSettings(){
        const win = window as any;
        if(win.UC_UI){
            win.UC_UI.showSecondLayer();
        }else{
            console.info('UC_UI is not defiend')
        }
    }

}